const INITIAL_STATE = {
  loading: false,
  list: {
    content: [],
  },
  error: false,
  errors: [],
};

/**
 * @param {Object} state - Default application state
 * @param {Object} action - Action from action creator
 * @returns {Object} New state
 */
export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'USER_ACTION_SUBSCRIPTIONS_LOAD':
      return { ...state, loading: action.payload };
    case 'USER_ACTION_SUBSCRIPTIONS_FETCHED':
      return { ...state, list: { content: action.payload }, loading: false };
    case 'LAST_USER_ACTION_SUBSCRIPTION_LOAD':
      return { ...state, loading: action.payload };
    case 'LAST_USER_ACTION_SUBSCRIPTION_FETCHED':
      return { ...state, content: action.payload, loading: false };
    case 'CARD_USER_SUBSCRIPTION_ACTION_LOADING':
      return { ...state, loading: action.payload };
    default:
      return state;
  }
};
